<template>
<div class="card-wrapper"
     :class="{ 'card-hover': !onlyReadMode }"
     @click="clickEvent">

  <p class="card-title">{{ title }}</p>

  <div class="inner-wrapper">

    <div class="score-wrapper">

      <!-- <vue-odometer class="score-text"
                    format="(,ddd)"
                    :class="{ plus: !isNegetiveScore, minus: isNegetiveScore }"
                    :value="parseInt(score, 10)"
                    :duration="0"
                    animation="smooth"
                    theme="default"/> -->
      <div class="score-text" :class="{ plus: !isNegetiveScore, minus: isNegetiveScore }">{{commaScore}}       <span v-if="isWon" class="">원</span></div>

    </div>

    <div class="line"
         :class="{ 'active-line': !onlyReadMode ? stateName === value : false }">
    </div>
  </div>
</div>
</template>

<script type="text/babel">
import VueOdometer from 'v-odometer/src';

export default {
  name: 'CardComponent',
  props: {
    title: String,
    score: {
      type: [String, Number],
      default: 0,
    },
    type: {
      type: String,
      default: 'none',
    },
    value: {
      type: String,
      isRequired: true,
    },
    stateName: {
      type: String,
      isRequired: true,
    },
    onlyReadMode: {
      type: Boolean,
      default: false,
    },
    onClickEvent: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    VueOdometer,
  },
  computed: {
    commaScore() {
      return new Intl.NumberFormat().format(this.score);
    },
    isNegetiveScore() {
      return this.score < 0;
    },
    isWon() {
      return this.type === 'money';
    },
  },
  methods: {
    async clickEvent() {
      if (this.onlyReadMode) return;

      this.inputState = this.stateName;
      await this.onClickEvent();
    },
  },
  watch: {
    inputState(value) {
      this.$emit('input', value);
    },
  },
  data() {
    return {
      inputState: this.value || null,
    };
  },
  updated() {
    if (this.onlyReadMode) return;
    if (this.value !== this.stateName) this.inputState = this.value;
  },
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  width: 100%;
  height: auto;

  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  align-content: center;

  padding: 24px;

  background-color: rgb(255, 255, 255);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);

  transition: all 0.3s;
  transform: scale(1);

  .line {
    width: 0;

    position: absolute;
    bottom: 0;
    left: 0;

    transition: width 0.3s;
    height: 10px;

    background-color: rgb(77, 148, 146);
  }

  .active-line {
    width: 100%;
  }

  .card-title {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.8);
  }

  .inner-wrapper {
    height: auto;

    display: flex;
    flex-direction: column;

    justify-content: flex-start;
    align-items: flex-start;
    align-content: center;

    .score-wrapper {
      display: flex;
      flex-direction: row;

      .score-text {
        font-size: 36px;
        font-weight: 600;
        text-align: center;
      }

      .mark-text {
      }
    }

    .variance-wrapper {
      display: flex;

      .variance-text {
        font-size: 16px;
      }

      .variance-text.plus {
        color: rgb(49, 136, 255);
      }

      .variance-text.minus {
        color: rgb(255, 30, 97);
      }

      .mark-text {
        font-size: 16px;
      }
    }
  }
}

.card-hover {
  cursor: pointer;
}

.card-hover:hover {
  transform: scale(1.05);
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/dashboard/components/CardComponent.vue